/**
 * Taller de fabricacion y afilado de `/nuestra-tienda`: los cuatro servicios
 * en tarjetas y a quien llamar. Los contactos salen de `SITIO.taller`.
 */
import { SITIO } from '../../configuracion/sitio';
import { enlaceTelefono } from '../../utilidades/telefono';
import { Icono, type NombreIcono } from '../comunes/Icono';
import { TarjetaIcono } from './TarjetaIcono';

const SERVICIOS: { icono: NombreIcono; titulo: string; texto: string }[] = [
  { icono: 'herramienta', titulo: 'Fresas', texto: 'Fabricación de fresas para router o tupí.' },
  {
    icono: 'disco',
    titulo: 'Afilado',
    texto: 'Discos de corte y cuchillos para maquinaria industrial.',
  },
  { icono: 'broca', titulo: 'Brocas', texto: 'Fabricación de brocas para herraje y cabezales.' },
  { icono: 'brillo', titulo: 'Reparación', texto: 'Reparación y limpieza de insumos.' },
];

export function TallerTienda() {
  return (
    <section className="tienda-seccion tienda-taller" aria-labelledby="taller">
      <div className="tienda-seccion-cab">
        <p className="presentacion-antetitulo">Taller</p>
        <h2 id="taller">Fabricación y afilado</h2>
        <p>
          Máquinas automatizadas y de control numérico para fabricar, reparar y afilar herramientas
          de corte para la madera, al servicio de mueblistas, carpinteros y la industria.
        </p>
      </div>

      <ul className="tienda-tarjetas">
        {SERVICIOS.map((servicio) => (
          <TarjetaIcono key={servicio.titulo} icono={servicio.icono} titulo={servicio.titulo}>
            <p>{servicio.texto}</p>
          </TarjetaIcono>
        ))}
      </ul>

      <h3 className="tienda-subtitulo">Contacto del taller</h3>
      <ul className="tienda-contactos">
        {SITIO.taller.contactos.map((contacto) => (
          <li key={contacto.telefono}>
            <Icono nombre="persona" />
            <span>
              <span className="n">{contacto.nombre}</span>
              <a href={enlaceTelefono(contacto.telefono)}>{contacto.telefono}</a>
            </span>
          </li>
        ))}
        <li>
          <Icono nombre="correo" />
          <span>
            <span className="n">Correo del taller</span>
            <a href={`mailto:${SITIO.taller.email}`}>{SITIO.taller.email}</a>
          </span>
        </li>
      </ul>
    </section>
  );
}
